import React, {useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {
	Backdrop,
	Card,
	CardContent,
	CardHeader,
	CircularProgress, FormControl,
	Grid,
	InputLabel, MenuItem, Select,
	Typography
} from "@mui/material";
import clsx from "clsx";
import ResizableBox from "../../utils/ResizableBox";
import {Bar} from "react-chartjs-2";
import {categoriesV2} from "../../../../../utils/dictionaries/Categories";
import {spAslCode} from "../../../../../utils/dictionaries/Generics";
import {KeyboardDatePickerCompat} from "../../../../widgets/inputs/KeyboardDatePickerCompat";


const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di ticket per giorno suddivisi per categoria',
		},
	},
};

export const TicketCategoriaGiorno = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date(2022, 3, 1));
	const [filterBy, setFilterBy] = useState("SP_301");
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'Mockup',
				data: [0],
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				stack: 'Stack 0',
			},
		],
	})
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "ticket/getStatsByDayAndCategoria/" + moment(dataGrafico).format("DD-MM-YYYY") + "/" + filterBy, getConfig())
			.then((response) => {
				let datasets = [];
				Object.entries(categoriesV2).forEach(([, value]) => {
					datasets.push({
						label: value.label,
						data: response.data.map(elem => (elem.data[value.label] ? elem.data[value.label] : 0)),
						backgroundColor: value.color,
						stack: 'Stack 0',
					})
				})
				
				let newData1 = {
					labels: response.data.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")),
					datasets: datasets
				}
				setData(newData1)
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico, filterBy])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket Categoria - giorno</b></Typography>}
					subheader={"Numero di ticket (asse y) per giorno (asse x) suddivisi per categoria (colore). E' possibile filtrare per ASL e per data (data da <seleziona> a oggi)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<Grid container spacing={1}>
						<Grid item xs={6}>
							<KeyboardDatePickerCompat
									margin="normal"
									id="date-picker-dialog"
									label="Data"
									inputVariant="outlined"
									format="dd/MM/yyyy"
									value={dataGrafico}
									onChange={setDataGrafico}
									style={{
										width: "100%",
										marginTop: 8
									}}
									KeyboardButtonProps={{
										'aria-label': 'change date',
									}}
								/>
						</Grid>
						<Grid item xs={6}>
							<FormControl fullWidth={true} variant={"outlined"} className={classes.formControl}>
								<InputLabel id="asl-select">Asl</InputLabel>
								<Select
									variant={"outlined"}
									labelId="asl-select"
									id="asl"
									label={"Asl"}
									value={filterBy}
									onChange={(event) => setFilterBy(event.target.value)}
								>
									{
										Object.entries(spAslCode).map(([key, value]) => {
											return <MenuItem key={key} value={key}>{value}</MenuItem>
										})
									}
									<MenuItem value={"no-cdt"}>Callcenter Regionale (No Asl CdT)</MenuItem>
									<MenuItem value={"null"}>Tutte le ASL</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					</Grid>
					
					<ResizableBox width={1200} height={600}>
						<Bar options={options} data={data} type={"bar"}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
};
